export default __webpack_public_path__ + "static/media/avatar_158.decf21ed.png";